// extracted by mini-css-extract-plugin
export default {"tooltip":"vn-z","sharingV2":"wn-z","sharingIconsV2":"xn-z","links":"yn-z","link":"zn-z","facebookV2":"An-z","twitterV2":"Bn-z","pinterestV2":"Cn-z"};